// src/sections/FAQPartenaires.jsx
import React from "react";
import { Link } from "react-router-dom";

const QUESTIONS = [
  {
    q: "Y a-t-il un engagement ?",
    a: "Non. Vous pouvez commencer, tester, ajuster — et arrêter quand vous voulez. L’objectif est d’être simple et flexible pour les commerçants."
  },
  {
    q: "Quelle visibilité apporte l’application PACTE ?",
    a: "Votre commerce apparaît aux habitants de Claix (Bourg & Pont-Rouge), via l’app et des mises en avant (actus, offres, événements, parcours thématiques)."
  },
  {
    q: "Puis-je proposer une carte de fidélité numérique ?",
    a: "Oui. Les tampons/points se valident par QR code en boutique. Les cartes sont centralisées dans le téléphone des clients (fini le papier !)."
  },
  {
    q: "De quel matériel ai-je besoin ?",
    a: "Aucun matériel spécifique sauf un téléphone pour la gestion du commerce: un QR code imprimé suffit pour valider les passages. Nous fournissons les visuels et vous accompagnons."
  },
  {
    q: "Comment sont gérées les offres et les événements ?",
    a: "Depuis votre espace commerçant (ou avec notre aide) : vous publiez une offre en quelques secondes, et vous rejoignez les événements communs du réseau."
  },
  {
    q: "Ai-je accès à des statistiques ?",
    a: "Oui. Vous suivez les validations de fidélité, l’impact de vos offres et les périodes d’affluence. De quoi ajuster simplement votre communication."
  },
];

function Item({ i, q, a }) {
  const [open, setOpen] = React.useState(i === 0); // la 1re ouverte par défaut
  return (
    <div className="rounded-xl bg-[#F6F6F7] border border-black/5">
      <button
        type="button"
        onClick={() => setOpen(v => !v)}
        className="w-full flex items-center justify-between gap-4 px-4 sm:px-5 py-3 sm:py-3.5 text-left"
      >
        <span className="text-[14px] sm:text-[15px] font-semibold text-neutral-900">{q}</span>
        <svg
          className={`h-5 w-5 text-neutral-500 transition-transform ${open ? "rotate-180" : ""}`}
          viewBox="0 0 20 20" fill="currentColor"
        >
          <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.06l3.71-2.83a.75.75 0 1 1 .92 1.18l-4.19 3.2a.75.75 0 0 1-.92 0l-4.19-3.2a.75.75 0 0 1-.02-1.06z" />
        </svg>
      </button>

      <div className={`grid transition-all duration-300 ease-out ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
        <div className="overflow-hidden">
          <div className="px-4 sm:px-5 pb-4 sm:pb-5 text-[13px] sm:text-[14px] text-neutral-700">
            {a}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function FAQPartenaires() {
  return (
    <section className="mx-auto max-w-[1519px] px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
      <div className="text-center max-w-3xl mx-auto">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-asap font-semibold">
          Questions fréquentes des commerçants
        </h2>
        <p className="mt-4 text-[13px] sm:text-[15px] text-neutral-600 leading-relaxed">
          Tout pour démarrer sereinement avec PACTE : visibilité, fidélité, événements,
          statistiques… et un accompagnement simple à chaque étape.
        </p>
      </div>

      <div className="mt-8 sm:mt-10 max-w-3xl mx-auto flex flex-col gap-3 sm:gap-3.5">
        {QUESTIONS.map((it, i) => (
          <Item key={i} i={i} q={it.q} a={it.a} />
        ))}
      </div>

      <div className="flex items-center justify-center gap-4 mt-8 sm:gap-6">
        <Link
          to="/contact?type=partenaire#form"
          className="inline-flex items-center justify-center rounded-full bg-black text-white
                     px-6 py-3 text-sm font-medium shadow-[0_10px_24px_rgba(0,0,0,0.35)]
                     hover:opacity-90 transition"
        >
          Une autre question ? Devenez partenaire
        </Link>
      </div>
    </section>
  );
}